"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketOverviewItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_types_1 = require("@as-react/common-types");
const cotopaxi_1 = require("@as/cotopaxi");
const i18nConstants_1 = require("../../constants/i18nConstants");
const SessionStorageUtil_1 = require("../../util/SessionStorageUtil");
const BasketOverviewProductItem_1 = require("./basket-overview-item/BasketOverviewProductItem");
const StorageKeysConstants_1 = require("../../constants/StorageKeysConstants");
const ScrollUtil_1 = require("../../util/ScrollUtil");
const EventUtil_1 = require("../../util/EventUtil");
const EventEnum_1 = require("../../enums/EventEnum");
const BasketSelector_1 = require("../../redux/basket/selectors/BasketSelector");
const DeliveryPromiseUtil_1 = require("../../util/DeliveryPromiseUtil");
const BasketOverviewPromotionMessage_1 = require("./BasketOverviewPromotionMessage");
const BasketOverviewPaybackVoucherMessage_1 = require("./BasketOverviewPaybackVoucherMessage");
const BasketOverviewBuyAndGetMessages_1 = require("./BasketOverviewBuyAndGetMessages");
const BasketOverviewDynamicMessage_1 = require("./BasketOverviewDynamicMessage");
const SEPARATOR = '##';
const SEPARATOR_LENGTH = 2;
const PRODUCT_CODE_LENGTH = 10;
const APPLE_PAY_PAYMENT_ERROR_ID = 'applepaypaymenteprror-feedbackmessage';
const messageBoxSpacing = {
    mobile: { spacing: { marginBottom: 3 }, theme: cotopaxi_1.BoxTheme.TERTIARY_LIGHT },
    desktop: { spacing: { paddingLeft: 1, paddingRight: 1 } },
};
const BasketOverviewItems = ({ aemConfiguration, mainWebshopId, products, wishlistProducts, popupMessages, popupMessagesEnriched, paybackVoucherMessages, hasUnavailableProducts, dynamicMessages, pricing, vouchers, loadProductDataByProductCode, openPromoBasketPopup, deliveryPromiseExplanations, showMultilineDeliveryPromise, isCheckoutFlowDisabled, storeName, preSoldenMessage, setDisabledProducts, }) => {
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.checkout, i18nConstants_1.I18N_NAMESPACES.buy]);
    const deliveryInfo = (0, react_redux_1.useSelector)((0, BasketSelector_1.makeGetBasketDeliveryInfoState)());
    const [basketsHaveMerged, setBasketsHaveMerged] = (0, react_1.useState)(false);
    const [applePayPaymentError, setApplePayPaymentError] = (0, react_1.useState)(false);
    const [disabledProductsList, setDisabledProductsList] = (0, react_1.useState)({});
    const makeEnrichedMessages = () => {
        const enrichedMessages = [];
        if (popupMessages.length > 0) {
            popupMessages.forEach((popupMessage) => {
                if (popupMessage.startsWith(SEPARATOR)) {
                    enrichedMessages.push({
                        message: popupMessage.substring(PRODUCT_CODE_LENGTH + SEPARATOR_LENGTH + SEPARATOR_LENGTH),
                        productCode: popupMessage.substring(SEPARATOR_LENGTH, PRODUCT_CODE_LENGTH + SEPARATOR_LENGTH),
                    });
                }
                else {
                    enrichedMessages.push({
                        message: popupMessage,
                    });
                }
            });
        }
        return enrichedMessages;
    };
    const getEnrichedMessages = () => popupMessagesEnriched.length > 0 ? popupMessagesEnriched : makeEnrichedMessages();
    const enrichedMessages = getEnrichedMessages().filter((message) => !!message.message);
    const isProductDisabled = (product) => {
        let disabled = false;
        if (!isCheckoutFlowDisabled)
            return disabled;
        if ((0, DeliveryPromiseUtil_1.isDeliveryMessageCollectStoreOrHQ)(deliveryInfo.deliveryMessages)) {
            if (product.ccExcluded) {
                disabled = true;
                setDisabledProductsList(prev => (Object.assign(Object.assign({}, prev), { [product.productId]: common_types_1.CheckoutBlockedReason.CC_EXCLUDED })));
            }
            else if (product.sseProduct && !product.availableInSSEStore) {
                disabled = true;
                setDisabledProductsList(prev => (Object.assign(Object.assign({}, prev), { [product.productId]: common_types_1.CheckoutBlockedReason.SSE_PRODUCT })));
            }
            else if (product.specialtyStoreProduct && !product.availableInSpecialtyStore) {
                disabled = true;
                setDisabledProductsList(prev => (Object.assign(Object.assign({}, prev), { [product.productId]: common_types_1.CheckoutBlockedReason.SPECIALTY_PRODUCT })));
            }
        }
        else {
            if (product.sseProduct) {
                disabled = true;
                setDisabledProductsList(prev => (Object.assign(Object.assign({}, prev), { [product.productId]: common_types_1.CheckoutBlockedReason.SSE_PRODUCT })));
            }
        }
        return disabled;
    };
    const productsElements = (0, react_1.useMemo)(() => products.map((product, index, arr) => ((0, jsx_runtime_1.jsx)(BasketOverviewProductItem_1.BasketOverviewProductItem, { product: product, index: index, isLastItem: arr.length - 1 === index, deliveryPromiseExplanations: deliveryPromiseExplanations, showDeliveryPromise: showMultilineDeliveryPromise, storeName: storeName, isProductDisabled: isProductDisabled(product) }, `${product.productId}_${index}`))), [products, wishlistProducts, storeName]);
    (0, react_1.useEffect)(() => {
        setDisabledProducts(disabledProductsList);
        EventUtil_1.default.listen(EventEnum_1.EventEnum.APPLE_PAY_PAYMENT_FAILED, () => {
            setApplePayPaymentError(true);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const basketsHaveMergedCheck = SessionStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.BASKET_CHANGED_STORAGE_KEY);
        const applePayPaymentFailed = SessionStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.APPLE_PAY_PAYMENT_FAILED);
        if (basketsHaveMergedCheck) {
            SessionStorageUtil_1.default.removeItem(StorageKeysConstants_1.BASKET_CHANGED_STORAGE_KEY);
            setBasketsHaveMerged(basketsHaveMergedCheck);
        }
        else {
            setBasketsHaveMerged(false);
        }
        if (applePayPaymentFailed) {
            SessionStorageUtil_1.default.removeItem(StorageKeysConstants_1.APPLE_PAY_PAYMENT_FAILED);
            setApplePayPaymentError(applePayPaymentFailed);
        }
        else {
            setApplePayPaymentError(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (applePayPaymentError) {
            ScrollUtil_1.ScrollUtil.scrollToErrorElement(document.getElementById(APPLE_PAY_PAYMENT_ERROR_ID));
        }
    }, [applePayPaymentError]);
    (0, react_1.useEffect)(() => {
        const shouldOpenBuyAndGetPopup = !SessionStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.BUY_GET_POPUP_STORAGE_KEY);
        if (shouldOpenBuyAndGetPopup) {
            const message = enrichedMessages.find((messageItem) => !!messageItem.productCode);
            if (message) {
                !!message.productCode && loadProductDataByProductCode(message.productCode);
                openPromoBasketPopup(message.message);
                SessionStorageUtil_1.default.setItem(StorageKeysConstants_1.BUY_GET_POPUP_STORAGE_KEY, true);
            }
        }
    }, [enrichedMessages]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [hasUnavailableProducts && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginBottom: 3 }, theme: cotopaxi_1.BoxTheme.QUATERNARY }, desktop: { spacing: { paddingLeft: 1, paddingRight: 1 } }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.FeedbackMessage, { isTransparent: true, variant: cotopaxi_1.FeedbackMessageVariant.NEGATIVE, text: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:basket.hasUnavailableProducts`) }) })), applePayPaymentError && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { id: APPLE_PAY_PAYMENT_ERROR_ID, mobile: { spacing: { marginBottom: 3 }, theme: cotopaxi_1.BoxTheme.QUATERNARY }, desktop: { spacing: { paddingLeft: 1, paddingRight: 1 } }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.FeedbackMessage, { isTransparent: true, variant: cotopaxi_1.FeedbackMessageVariant.NEGATIVE, text: t(`${i18nConstants_1.I18N_NAMESPACES.buy}:buy.payment.applepay.error.generic`) }) })), basketsHaveMerged && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, Object.assign({}, messageBoxSpacing, { children: (0, jsx_runtime_1.jsx)(cotopaxi_1.FeedbackMessage, { isTransparent: true, variant: cotopaxi_1.FeedbackMessageVariant.INFO, iconSize: cotopaxi_1.IconSize.MEDIUM, text: t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:basket.merged`) }) }))), (0, jsx_runtime_1.jsx)(BasketOverviewPaybackVoucherMessage_1.BasketOverviewPaybackVoucherMessage, { paybackVoucherMessages: paybackVoucherMessages, messageBoxSpacing: messageBoxSpacing }), (0, jsx_runtime_1.jsx)(BasketOverviewBuyAndGetMessages_1.BasketOverviewBuyAndGetMessages, { enrichedMessages: enrichedMessages, loadProductDataByProductCode: loadProductDataByProductCode, openPromoBasketPopup: openPromoBasketPopup, messageBoxSpacing: messageBoxSpacing }), (0, jsx_runtime_1.jsx)(BasketOverviewDynamicMessage_1.BasketOverviewDynamicMessage, { dynamicMessages: dynamicMessages, products: products, pricing: pricing, vouchers: vouchers, messageBoxSpacing: messageBoxSpacing }), (0, jsx_runtime_1.jsx)(BasketOverviewPromotionMessage_1.BasketOverviewPromotionMessage, { mainWebshopId: mainWebshopId, aemConfiguration: aemConfiguration, products: products, preSoldenMessage: preSoldenMessage, messageBoxSpacing: messageBoxSpacing }), productsElements] }));
};
exports.BasketOverviewItems = BasketOverviewItems;
